import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CarouselArrowPosition,
  CarouselScrollBehaviour,
} from '@freelancer/ui/carousel';
import { IconColor } from '@freelancer/ui/icon';
import { PictureLayout, PictureLoadMethod } from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-as-seen-on',
  template: `
    <div class="CompaniesTrust">
      <p
        class="text-light text-body-16 CompaniesTrust-text tablet:text-body-12 desktop:text-body-20 mb-small tablet:mb-none tablet:mr-mid desktop:mr-xxlarge"
        i18n="As used by text"
      >
        As seen on
      </p>
      <div class="CompaniesTrust-companies">
        <div
          class="CompaniesTrust-companies-list mb-small tablet:mb-none mobile:hide"
        >
          <ng-container *ngTemplateOutlet="newYorkTimes"></ng-container>
          <ng-container *ngTemplateOutlet="cnbc"></ng-container>
          <ng-container *ngTemplateOutlet="wallStreetJournal"></ng-container>
          <ng-container *ngTemplateOutlet="cnn"></ng-container>
          <ng-container *ngTemplateOutlet="bloomberg"></ng-container>
          <ng-container *ngTemplateOutlet="yahoo"></ng-container>
          <ng-container *ngTemplateOutlet="businessInsider"></ng-container>
          <ng-container *ngTemplateOutlet="forbes"></ng-container>
        </div>
        <fl-carousel
          class="mobile:show"
          [currentIndex]="0"
          [slidesToShow]="3"
          [padding]="4"
          [arrowPosition]="CarouselArrowPosition.OUTSIDE"
          [scrollBehaviour]="CarouselScrollBehaviour.GROUP"
        >
          <fl-carousel-prev-btn>
            <fl-icon
              class="CarouselArrow"
              [color]="IconColor.LIGHT"
              [name]="'ui-arrow-back'"
              [useIconFont]="true"
            ></fl-icon>
          </fl-carousel-prev-btn>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="newYorkTimes"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="cnbc"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="wallStreetJournal"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="cnn"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="bloomberg"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="yahoo"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="businessInsider"></ng-container>
          </fl-carousel-item>
          <fl-carousel-item>
            <ng-container *ngTemplateOutlet="forbes"></ng-container>
          </fl-carousel-item>

          <fl-carousel-next-btn>
            <fl-icon
              class="CarouselArrow"
              [color]="IconColor.LIGHT"
              [name]="'ui-arrow-forward'"
              [useIconFont]="true"
            ></fl-icon>
          </fl-carousel-next-btn>
        </fl-carousel>
      </div>
    </div>
    <ng-template #newYorkTimes>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="The New York Times Icon"
          i18n-alt="The New York Times Icon Alternative Text"
          [src]="'home/as-seen-on/the-new-york-times-darkmode.svg'"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>
    <ng-template #cnbc>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="CNBC Icon"
          i18n-alt="CNBC Icon Alternative Text"
          [src]="'home/as-seen-on/cnbc-darkmode.svg'"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>
    <ng-template #wallStreetJournal>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          class="mr-mid tablet:mr-none"
          alt="Wall Street Journal Icon"
          i18n-alt="Wall Street Journal Icon Alternative Text"
          [src]="'home/as-seen-on/wall-street-journal-darkmode.svg'"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>

    <ng-template #cnn>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="CNN Icon"
          i18n-alt="CNN Icon Alternative Text"
          [height]="27"
          [src]="'home/as-seen-on/cnn-darkmode.svg'"
          [width]="57"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>

    <ng-template #bloomberg>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="Bloomberg Icon"
          i18n-alt="Bloomberg Icon Alternative Text"
          [height]="21"
          [src]="'home/as-seen-on/bloomberg-darkmode.svg'"
          [width]="110"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>

    <ng-template #yahoo>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="Yahoo Finance Icon"
          i18n-alt="Yahoo Finance Icon Alternative Text"
          [height]="31"
          [src]="'home/as-seen-on/yahoo-finance-darkmode.svg'"
          [width]="85"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>
    <ng-template #businessInsider>
      <div class="ImageWrapper mr-large tablet:mr-xsmall desktop:mr-large">
        <fl-picture
          alt="Business Insider Icon"
          i18n-alt="Business Insider Icon Alternative Text"
          [height]="12"
          [src]="'home/as-seen-on/business-insider-darkmode.svg'"
          [width]="184"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>

    <ng-template #forbes>
      <div class="ImageWrapper">
        <fl-picture
          alt="Forbes Icon"
          i18n-alt="Forbes Icon Alternative Text"
          [height]="20"
          [src]="'home/as-seen-on/forbes-darkmode.svg'"
          [width]="76"
          [layout]="PictureLayout.RESPONSIVE"
          [loadMethod]="PictureLoadMethod.LAZY"
        ></fl-picture>
      </div>
    </ng-template>
  `,
  styleUrls: ['./as-seen-on.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsSeenOnComponent {
  CarouselArrowPosition = CarouselArrowPosition;
  CarouselScrollBehaviour = CarouselScrollBehaviour;
  IconColor = IconColor;
  PictureLayout = PictureLayout;
  PictureLoadMethod = PictureLoadMethod;
}
